export default "__VITE_ASSET__CWU_jpzS__"